// Color scheme utility for field groups - Primary colors only, consistent order, no duplicates
const GROUP_COLORS = [
  { primary: '#FF0000', secondary: '#FFE6E6', border: '#FF6666' }, // Red
  { primary: '#0000FF', secondary: '#E6E6FF', border: '#6666FF' }, // Blue  
  { primary: '#FFFF00', secondary: '#FFFEE6', border: '#FFFF66' }, // Yellow
  { primary: '#00FF00', secondary: '#E6FFE6', border: '#66FF66' }, // Green
  { primary: '#FF00FF', secondary: '#FFE6FF', border: '#FF66FF' }, // Magenta
  { primary: '#00FFFF', secondary: '#E6FFFF', border: '#66FFFF' }, // Cyan
  { primary: '#FFA500', secondary: '#FFF2E6', border: '#FFB866' }, // Orange
  { primary: '#800080', secondary: '#F0E6F0', border: '#B366B3' }, // Purple
  { primary: '#000000', secondary: '#F0F0F0', border: '#666666' }, // Black
  { primary: '#FF1493', secondary: '#FFE6F1', border: '#FF69B4' }, // Deep Pink
];

export const groupColorService = {
  /**
   * Get color scheme for a group by index
   */
  getColorByIndex: (index: number) => {
    return GROUP_COLORS[index % GROUP_COLORS.length];
  },

  /**
   * Get color scheme for a group by ID (deterministic)
   */
  getColorById: (groupId: string) => {
    // Create a simple hash from the groupId to ensure consistent colors
    let hash = 0;
    for (let i = 0; i < groupId.length; i++) {
      const char = groupId.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32-bit integer
    }
    const index = Math.abs(hash) % GROUP_COLORS.length;
    return GROUP_COLORS[index];
  },

  /**
   * Get all available color schemes
   */
  getAllColors: () => GROUP_COLORS,

  /**
   * Get color scheme by group object
   */
  getGroupColor: (group: { id: string; color?: string }) => {
    if (group.color) {
      // If group has a custom color, try to find matching scheme or create one
      const existingScheme = GROUP_COLORS.find(scheme => scheme.primary === group.color);
      if (existingScheme) {
        return existingScheme;
      }
      // Create a custom scheme from the primary color
      return {
        primary: group.color,
        secondary: group.color + '20', // Add transparency
        border: group.color + '60'
      };
    }
    return groupColorService.getColorById(group.id);
  },

  /**
   * Get color scheme by primary color (for persisted colors)
   */
  getColorByPrimaryColor: (primaryColor: string) => {
    // Try to find exact match in predefined colors
    const existingScheme = GROUP_COLORS.find(scheme => 
      scheme.primary.toLowerCase() === primaryColor.toLowerCase()
    );
    if (existingScheme) {
      return existingScheme;
    }
    // Create a custom scheme from the primary color
    return {
      primary: primaryColor,
      secondary: primaryColor + '20', // Add transparency
      border: primaryColor + '60'
    };
  }
};

export default groupColorService;